import { useNavigate } from 'react-router-dom';
import {
  BarChart3,
  Car,
  LayoutDashboard,
  Package,
  ShoppingBag,
  Settings as SettingsIcon,
  Plus,
} from 'lucide-react';
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from '@/components/ui/command';
import { t } from '@/lib/i18n';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CommandPalette({ open, onOpenChange }: Props) {
  const navigate = useNavigate();

  const go = (to: string) => {
    onOpenChange(false);
    navigate(to);
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder={t('cmdk.placeholder')} />
      <CommandList>
        <CommandEmpty>{t('common.noData')}</CommandEmpty>

        <CommandGroup heading={t('cmdk.sectionActions')}>
          <CommandItem onSelect={() => go('/keys/new')}>
            <Plus className="mr-2 h-4 w-4" />
            {t('cmdk.newKey')}
          </CommandItem>
        </CommandGroup>

        <CommandSeparator />

        <CommandGroup heading={t('cmdk.sectionNav')}>
          <CommandItem onSelect={() => go('/')}>
            <LayoutDashboard className="mr-2 h-4 w-4" />
            {t('nav.dashboard')}
          </CommandItem>
          <CommandItem onSelect={() => go('/keys')}>
            <Package className="mr-2 h-4 w-4" />
            {t('nav.inventory')}
          </CommandItem>
          <CommandItem onSelect={() => go('/sales')}>
            <ShoppingBag className="mr-2 h-4 w-4" />
            {t('nav.sales')}
          </CommandItem>
          <CommandItem onSelect={() => go('/compat')}>
            <Car className="mr-2 h-4 w-4" />
            {t('nav.compat')}
          </CommandItem>
          <CommandItem onSelect={() => go('/reports')}>
            <BarChart3 className="mr-2 h-4 w-4" />
            {t('nav.reports')}
          </CommandItem>
          <CommandItem onSelect={() => go('/settings')}>
            <SettingsIcon className="mr-2 h-4 w-4" />
            {t('nav.settings')}
          </CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
